export default __webpack_public_path__ + "static/media/brokerage-trucking-not-selected.105b2528.svg";